import { ChartIconStatic } from "../TacticIcons/ChartIconStatic";

interface ChartIconAnimatedProps {
  width?: number;
  height?: number;
  className?: string;
  duration?: number;
  easing?: string;
  color?: string;
  hoverColor?: string;
  strokeWidth?: number;
}

export const ChartIconAnimated = ({
  width = 24,
  height = 24,
  className,
  duration = 0.6,
  color = "currentColor",
  hoverColor = color,
  strokeWidth = 2
}: ChartIconAnimatedProps) => {
  return (
    <div className={`${className || ""} group`} style={{ width, height }}>
      <div className="hidden group-hover:block">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
        >
          {/* axes */}
          <path
            d="M3 3v16a2 2 0 0 0 2 2h16"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <animate
              attributeName="stroke"
              values={`${color}; ${hoverColor}; ${color}`}
              dur={`${duration * 2}s`}
              begin="0s"
              repeatCount="indefinite"
              calcMode="spline"
              keySplines="0.42 0 0.58 1; 0.42 0 0.58 1"
              keyTimes="0; 0.5; 1"
            />
          </path>

          {/* right bar: 12 -> 16 -> 12, keep bottom aligned */}
          <rect
            x="15"
            y="5"
            width="4"
            height="12"
            rx="1"
            stroke={color}
            strokeWidth={strokeWidth}
          >
            <animate
              attributeName="height"
              values="12;16;12"
              keyTimes="0;0.5;1"
              dur={`${duration * 2}s`}
              begin="0s"
              repeatCount="indefinite"
              calcMode="spline"
              keySplines="0.42 0 0.58 1; 0.42 0 0.58 1"
            />
            <animate
              attributeName="y"
              values="5;1;5"
              keyTimes="0;0.5;1"
              dur={`${duration * 2}s`}
              begin="0s"
              repeatCount="indefinite"
              calcMode="spline"
              keySplines="0.42 0 0.58 1; 0.42 0 0.58 1"
            />
            <animate
              attributeName="stroke"
              values={`${color}; ${hoverColor}; ${color}`}
              dur={`${duration * 2}s`}
              begin="0s"
              repeatCount="indefinite"
              calcMode="spline"
              keySplines="0.42 0 0.58 1; 0.42 0 0.58 1"
              keyTimes="0; 0.5; 1"
            />
          </rect>

          {/* left bar: 9 -> 14 -> 9, start later for wave */}
          <rect
            x="7"
            y="8"
            width="4"
            height="9"
            rx="1"
            stroke={color}
            strokeWidth={strokeWidth}
          >
            <animate
              attributeName="height"
              values="9;14;9"
              keyTimes="0;0.5;1"
              dur={`${duration * 2}s`}
              begin={`${0.15}s`}
              repeatCount="indefinite"
              calcMode="spline"
              keySplines="0.42 0 0.58 1; 0.42 0 0.58 1"
            />
            <animate
              attributeName="y"
              values="8;3;8"
              keyTimes="0;0.5;1"
              dur={`${duration * 2}s`}
              begin={`${0.15}s`}
              repeatCount="indefinite"
              calcMode="spline"
              keySplines="0.42 0 0.58 1; 0.42 0 0.58 1"
            />
            <animate
              attributeName="stroke"
              values={`${color}; ${hoverColor}; ${color}`}
              dur={`${duration * 2}s`}
              begin={`${0.15}s`}
              repeatCount="indefinite"
              calcMode="spline"
              keySplines="0.42 0 0.58 1; 0.42 0 0.58 1"
              keyTimes="0; 0.5; 1"
            />
          </rect>
        </svg>
      </div>
      <div className="block group-hover:hidden">
        <ChartIconStatic
          width={width}
          height={height}
          color={color}
          strokeWidth={strokeWidth}
        />
      </div>
    </div>
  );
};
